import * as React from "react";
import { Logger } from "../util/Logger";
import "../scss/clock.scss"
import moment from 'moment'

export interface ClockProps {

}
const sourceFileName = "ClockComponent.tsx";
export class ClockComponent extends React.Component<ClockProps, { time: any, date: any }> {
    
    intervalID: any;
    constructor(props: ClockProps) {
        super(props);
        //render clock through state(component re-renders every time state changes)
        
        this.state = {
            time: moment().format("HH:mm:ss"),
            date: moment().format("DD.MM.YYYY")
        };
    }
    public render() {

        return (
            <div className="clock-left">
                <div className="clock-time">
                    <span>{this.state.time}</span>
                </div>
                <div className="clock-date">
                    <span>
                        {this.state.date}
                    </span>
                </div>
            </div>
        )
    }
    componentDidMount() {
        Logger.info(sourceFileName,"Clockcomponent mounted!");
        //start intervall
        this.intervalID = setInterval(
            () => this.tick(),
            1000
        );
    }
    componentWillUnmount() {
        Logger.info(sourceFileName,"Clockcomponent unmounted!");
        clearInterval(this.intervalID);
    }
    tick() {
        //set state so the component will be re-renderd
        this.setState({
            time: moment().format("HH:mm:ss"),
            date: moment().format("DD.MM.YYYY")
        });
    }
   
}

export default ClockComponent;